app.service('previewOrder', function (broker, loading, html, modal, deliveryLocation, deliveryPoints, ajaxOrder, front, scroll) {

	function refresh(callback) {
		loading.start();
		$.ajax({
			url: '/order-path-preview.ltr',
			dataType: "json",
			data: {
				refresh: true
			},
			success: function (json) {
				loading.stop();

				let $box = $('#preview-list');
				$box.html(json.previewRight);
				let $box2 = $('#preview-order-steps');
				$box2.html(json.previewLeft);
				if (callback) {
					callback();
				}
				$box.attr('wdio-ready', parseInt(Math.random() * 1000000000));
				broker.trigger('PREVIEW_REFRESH');
			},
			error: function () {
				modal.alert('Błąd odświeżenia stanu zamówienia. Strona zostanie odświeżona.', function () {
					loading.reload({ soft: true });
				});
			}
		});
	}

	function changePriceDisplayType(action) {
		loading.start();
		if (front.page() == 'basket') {
			$.ajax({
				url: '/cart-change-price-type.ltr',
				cache: false,
				dataType: 'json',
				type: 'POST',
				data: {
					priceType: action,
					refresh: true
				},
				success: function () {
					broker.trigger('REFRESH_BASKET_VIEW', { type: 'price-format-' + (action == 'NORMAL' ? 'normal' : 'installment') });
				},
				error: function () {
					loading.stop();
					modal.alert('Błąd zmiany kontekstu koszyka. Spróbuj ponownie');
				}
			});
		} else {
			$.ajax({
				url: '/order-path-change-price-type.ltr',
				cache: false,
				dataType: 'json',
				type: 'POST',
				data: {
					priceType: action,
					refresh: true
				},
				success: function () {
					refresh();
				},
				error: function () {
					loading.stop();
					modal.alert('Błąd zmiany kontekstu ścieżki zakupowej. Spróbuj ponownie');
				}
			});
		}
	}

	let isOneInit = false;
	function init() {
		if (!isOneInit) {
			isOneInit = true;
			$('body').on('click', '.js-show-more-products', function () {
				$(this).closest('.basket-list').toggleClass('show-all');
			}).on('click', '.js-show-user-data', function () {
				$('#short-client-data').remove();
				scroll.to({ $element: $('#returning-user-data-box'), speed: 100 });
			}).on('click', '.js-scroll-delivery-time', function () {
				scroll.to({ $element: $('form') });
			}).on('click', '.js-scroll-payment', function () {
				scroll.to({ $element: $('form') });
			}).on('click', '.js-price-installment', function () {
				changePriceDisplayType('INSTALMENT');
			}).on('click', '.js-price-normal', function () {
				changePriceDisplayType('NORMAL');
			}).on('click', '.js-show-shops', function () {
				if (html.has('points-on-modal')) {
					const $this = $(this);
					deliveryPoints.show({
						longitude: $this.data('longitude'),
						latitude: $this.data('latitude'),
						selectedPoint: $this.data('point')
					});
				} else {
					deliveryLocation.show();
				}
			}).on('click', '.js-show-inpost, .js-show-points, .js-show-pickup-point', function () {
				var $this = $(this);
				deliveryPoints.show({
					longitude: $this.data('longitude'),
					latitude: $this.data('latitude'),
					point: $this.data('point')
				});
			}).on('click', '.js-nav-back, .js-nav-step, .js-back-to-edit', function (event) {
				const $this = $(this);
				const href = $this.data('url') || $this.attr('href');
				if (href && href.length > 0) {
					if (testAB.getVar('ajax-order2') === 'B' && front.getParam('ajaxOrder')) {
						ajaxOrder.get({
							href: href,
							scroll: $this.data('scroll') || '#container',
							click: $this.data('click')
						});
						event.preventDefault();
						//event.stopPropagation();
					} else {
						loading.redirect({ href: href, soft: false });
					}
				} else {
					console.log('Błąd przekierowania na ścieżce. Brak adresu docelowego.');
				}
			}).on('click', '.js-expand-additional-entity-info', function () {
				const $btn = $(this);
				const $info = $('#additional-entity-info');
				const expanded = $btn.attr('aria-expanded') === 'true';

				$btn.attr('aria-expanded', !expanded);
				$info.toggleClass('expanded', !expanded);
				$info.attr('aria-hidden', expanded);
			});
			broker.on('K3_REFRESH', function (event, callback) {
				refresh(callback);
			});
			broker.on('PREVIEW_REFRESH', function (event) {
				//marketingDescription();
			});
		}
	}
	return {
		init
	};
});
